export const MENU_ITEMS_NUM = 5;
